import { render, staticRenderFns } from "./TheFamilyHistoryFeedback.vue?vue&type=template&id=56a6da28&"
import script from "./TheFamilyHistoryFeedback.vue?vue&type=script&lang=js&"
export * from "./TheFamilyHistoryFeedback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports